// Values come from .env.<mode> (development, staging, production, test) and are checked at build
// time in vite.config.ts. They are compiled into the bundle, so they must never hold secrets.
const apiUrl = import.meta.env.VITE_API_URL;

export const env = {
  name: import.meta.env.MODE,
  apiUrl,
  apiBaseUrl: new URL('/api/v1', apiUrl).href,
  publicWebUrl: import.meta.env.VITE_PUBLIC_WEB_URL,
  // OAuth client ids; a provider's sign-in button is shown only when its id is set.
  googleClientId: import.meta.env.VITE_GOOGLE_CLIENT_ID || undefined,
  appleClientId: import.meta.env.VITE_APPLE_CLIENT_ID || undefined,
};
